const relationShips = [
  {id: 1, key: "1", unaccent_name: "chua lien he", label: "Chưa liên hệ", name: "Chưa liên hệ"},
  {id: 2, key: "2", unaccent_name: "lien he dien thoai", label: "Liên hệ điện thoại", name: "Liên hệ điện thoại"},
  {id: 3, key: "3", unaccent_name: "da gap va chua than", label: "Đã gặp và chưa thân", name: "Đã gặp và chưa thân"},
  {id: 4, key: "4", unaccent_name: "than thiet", label: "Thân thiết", name: "Thân thiết"}
]

const findRelate = (id) => relationShips.find(r => r.id*1 === id*1)
export {
  relationShips,
  findRelate
}